import { ChevronLeftIcon, ChevronRightIcon } from '@radix-ui/react-icons'
import { HoverableToggle } from 'components/HoverableToggle'
import { usePointCloudContext } from 'features/pointClouds'
import React from 'react'
import styled from 'styled-components'

import { ObservationPanelContent } from './components/observationPanel/ObservationPanelContent'

export const SIDEBAR_WIDTH = 500

const SidebarContainer = styled.div<{ $isCollapsed: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: ${({ $isCollapsed }) => ($isCollapsed ? 0 : SIDEBAR_WIDTH)}px;
  background-color: rgba(0, 0, 0, 0.9);
  color: white;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  overflow-y: auto;
  overflow-x: hidden;
  padding: ${({ $isCollapsed }) => ($isCollapsed ? 0 : '10px')};
  gap: 10px;
  transition: width 0.3s ease;
`

const FloatingToggleButtonContainer = styled.div<{ $isCollapsed: boolean }>`
  position: absolute;
  top: 10px;
  left: ${({ $isCollapsed }) => ($isCollapsed ? 0 : SIDEBAR_WIDTH)}px;
  z-index: 1001;
  transition: left 0.3s ease;
  padding-left: 5px;
`

export const PointCloudSidebar: React.FC = () => {
  const { isSidebarCollapsed, setIsSidebarCollapsed } = usePointCloudContext()

  return (
    <>
      <SidebarContainer $isCollapsed={isSidebarCollapsed}>
        {!isSidebarCollapsed && (
          <>
            <ObservationPanelContent />
          </>
        )}
      </SidebarContainer>

      <FloatingToggleButtonContainer $isCollapsed={isSidebarCollapsed}>
        <HoverableToggle
          trigger={
            <div>
              {isSidebarCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </div>
          }
          content={isSidebarCollapsed ? 'Show Sidebar' : 'Hide Sidebar'}
          pressed={isSidebarCollapsed}
          onPressedChange={setIsSidebarCollapsed}
          onKeyDown={(event: React.KeyboardEvent) => {
            if (event.key === ' ' || event.code === 'Space') {
              event.preventDefault()
            }
          }}>
          {isSidebarCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </HoverableToggle>
      </FloatingToggleButtonContainer>
    </>
  )
}
